import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './styles.css';
import './components/role-dialog.css';
import './components/board-workspace.css';
import './components/student-play-workspace.css';
import './components/homework-grading.css';
import './components/review-studio.css';
import './components/homework-list.css';
import './components/warm-study.css';
import './components/sky-study.css';

const root = document.querySelector<HTMLElement>('#root');
if (root === null) throw new Error('Missing Web application root.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
